/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Not_FoundInputs */

const en_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No article found!`)
};

const ar_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد مقال!`)
};

const bn_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনো আর্টিকেল মেলেনি!`)
};

const de_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Artikel gefunden!`)
};

const es_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡No se encontró ningún artículo!`)
};

const fr_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun article trouvé !`)
};

const pt_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum artigo encontrado!`)
};

const zh_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到文章！`)
};

const tr_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makale bulunamadı!`)
};

const ru_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статья не найдена!`)
};

const pl_note_not_found = /** @type {(inputs: Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono artykułu!`)
};

/**
* | output |
* | --- |
* | "No article found!" |
*
* @param {Note_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const note_not_found = /** @type {((inputs?: Note_Not_FoundInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Not_FoundInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_note_not_found(inputs)
	if (locale === "bn") return bn_note_not_found(inputs)
	if (locale === "de") return de_note_not_found(inputs)
	if (locale === "es") return es_note_not_found(inputs)
	if (locale === "fr") return fr_note_not_found(inputs)
	if (locale === "pt") return pt_note_not_found(inputs)
	if (locale === "zh") return zh_note_not_found(inputs)
	if (locale === "tr") return tr_note_not_found(inputs)
	if (locale === "ru") return ru_note_not_found(inputs)
	if (locale === "pl") return pl_note_not_found(inputs)
	return en_note_not_found(inputs)
});